<div class="row mt-5 mb-2">
    <div class="col-3"></div>
    <div class="col-6">

        <div class="example-header">
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>
        </div>

    </div>

</div>


<div class="row mt-5">
    <div class="col-1"></div>
    <div class="col-md-10">



        <div class="mb-5 col-xs">
            <div class="example-container mat-elevation-z8">
                <mat-table #table [dataSource]="listResult" matSort>
                    <!-- Position Column -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p> ID</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.id}}
                            <p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="civilite">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Civilité</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.civilite}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef>
                            <p> Nom</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.nom}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="adresse">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Adresse</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.adresse}}</p>
                        </mat-cell>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="codepostal">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Code postal</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.codepostal}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ville">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p> ville</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>{{element.ville}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="tel1">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Tel1</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.telmob}}</p>
                        </mat-cell>
                    </ng-container>
                    <!-- Weight Column -->
                    <ng-container matColumnDef="tel2">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Tel2</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.telfix}}</p>


                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="mail">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Email</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.mail}}</p>


                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="commentaire">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p>Commentaire</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">

                            <p> {{element.commentaire}}</p>


                        </mat-cell>
                    </ng-container>





                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>

            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12 text-center">
              <a  class="previous" (click)="pre()">&laquo; Précédent  </a>
              <a  class="next" (click)="suiv()">Suivant &raquo; </a>
            </div>
        </div>
    </div>

</div>

<div class="row ">
    <div class="col-1"></div>
    <div class="col-md-10">

        <div class="main-card mb-3 card" style="height: 94%;">
            <div class="card-body">

                <form [formGroup]="uploadForm2" (ngSubmit)="uploadSubmit2()">
                    <mat-card-content>


                        <input formControlName="document" class="foo" type="file" ng2FileSelect [uploader]="uploader2"
                            (change)="onFileChange($event)" /><br />

                        <hr>
                        <div class="drop-zone">
                            <div ng2FileDrop [uploader]="uploader2" style="min-height: 150px;
                    border: 2px dashed #00B5B8;
                    background: #F5F7FA;" class="drop-zone">
                                <h2 class="text-center mt-5">Glissez le document Provisoire</h2>
                            </div>
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th width="100%">

                                    </th>
                                    <th width="10%">

                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of uploader2.queue;let x=index">
                                    <th width="100%">
                                        document
                                    </th>
                                    <th class="text-center" width="20%">
                                        <button type="button" class="btn btn-light" (click)="effacer()" (click)="item.remove()">
                                           Annuler
                                        </button>
                                    </th>
                                </tr>




                            </tbody>
                        </table>
                        <table class="table" width="100%" *ngIf="dataExel != null">
                            <thead>
                                <tr>
                                    <th>Civilité</th>
                                    <th>Nom</th>

                                    <th>Adresse</th>
                                    <th>code postal</th>
                                    <th>email</th>
                                    <th>Tél Mob</th>
                                    <th>TélFixe</th>
                                    <th>Commentaire</th>

                                </tr>
                            </thead>
                            <tbody *ngFor="let row of dataExel;let i =index">
                                <tr *ngIf="i &#60; 4">
                                    <td>{{row.Civilite}}</td>
                                    <td>{{row.Nom}}</td>
                                    <td>{{row.Adresse}}</td>
                                    <td>{{row.Codepostal}}</td>
                                    <td>{{row.Email}}</td>
                                    <td>{{row.Telephonemobil}}</td>
                                    <td>{{row.Telephonefixe}}</td>
                                    <td>{{row.Commentaire}}</td>


                                </tr>
                            </tbody>
                        </table>
                        <br>
                    </mat-card-content>
                </form>

            </div>

            <div class=" d-block text-left card-footer">
                <button class="mb-2 mr-2 btn btn-primary" (click)="uploadSubmit2()">Enregistrer</button>
                <button class="mb-2 mr-2 btn btn-light"  [disabled]="disabledExport" (click)="exporter()">Télécharger</button>
                <p>{{testExport}}</p>

            </div>

            <div class="alert alert-warning" *ngIf="isOk2 == false">
                Upload échouée!
            </div>

            <div class="alert alert-success" *ngIf="isOk2 == true">
                Votre upload est réussie!
            </div>
            <div class="alert alert-warning" *ngIf="expPro == false">
                Téléchargemment échouée!
            </div>

            <div class="alert alert-success" *ngIf="expPro == true">
                Télechargemment Votre upload est réussie!
            </div>
        </div>



    </div>
</div>